import { render, staticRenderFns } from "./FrameMain.vue?vue&type=template&id=174af352&scoped=true"
import script from "./FrameMain.vue?vue&type=script&lang=js"
export * from "./FrameMain.vue?vue&type=script&lang=js"
import style0 from "./FrameMain.vue?vue&type=style&index=0&id=174af352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174af352",
  null
  
)

export default component.exports